import React, { useEffect, useState } from 'react'
import Navbar from '../Navbar';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import Menu_Items from '../Menu_Items';
import { MdEditSquare } from "react-icons/md";

function Edit_Configuration() {
    const { E_id, id } = useParams();
    const [edit_val, setedit_val] = useState({});
    const navigate = useNavigate();
    const menus = [
        {
            name: 'Integrations',
            id
        },
        {
            name: 'Users',
            id
        }
    ];
    const geteditdetails = async () => {
        await axios.get(`/integ/edit/${E_id}`).then((res) => {
            setedit_val(res.data);
        })
            .catch((err) => {
                toast.error("Edit Configuration Error", {
                    autoClose: 2000, // 2 seconds
                });
            })
    };
    const inputdata = (e) => {
        setedit_val({ ...edit_val, [e.target.id]: e.target.value });
    };
    const check = async () => {
        await axios.post("/integ/check", edit_val).then(async (res) => {
            toast.success(res.data, {
                autoClose: 2000, // 2 seconds
            });
        })
            .catch(() => {
                toast.error("Edit Configuration Check Error", {
                    autoClose: 2000, // 2 seconds
                });
            })
    };
    const submit = async () => {
        await axios.patch(`/integ/edit/${E_id}`, edit_val).then(async (res) => {
            navigate(`/integ/${id}`);
        })
            .catch((err) => {
                toast.error("Integration Details Couldn't be Updated", {
                    autoClose: 2000, // 2 seconds
                });

            });

    };
    useEffect(() => {
        geteditdetails();
    }, []);
    return (
        <div className='container df fdc jb ac'>
            <Navbar />
            <div className='main_box df'>
                <Menu_Items menu={menus} />
                <div className='content df fdc ac'>
                    <div className='page_header df jb ac'>
                        <div className='w90 df ac'><MdEditSquare className='page_icon db' />
                            <p>Edit Integration</p></div>
                    </div>
                    <div className='box'>
                        <div className='create_box'>
                            <div>
                                <label htmlFor='integration_name'>Integration Name</label>
                                <input type='search' id='name' onChange={(e) => { inputdata(e) }} value={edit_val.name ? edit_val.name : ''} />
                            </div>
                            <div>
                                <label htmlFor='dbtype'>Database type</label>
                                <select id='dbtype' onChange={(e) => { inputdata(e) }} value={edit_val.dbtype ? edit_val.dbtype : ''}>
                                    <option value={""}>Select Database</option>
                                    <option value={"mysql"}>Mysql</option>
                                    <option value={"postgres"}>Postgres</option>
                                    <option value={"oracle"}>Oracle</option>
                                    <option value={"others"}>Others</option>
                                </select>
                            </div>
                            <div>
                                <label htmlFor='integration_database'>Database Name</label>
                                <input type='search' id='db' onChange={(e) => { inputdata(e) }} value={edit_val.db ? edit_val.db : ''} />
                            </div>
                            <div>
                                <label htmlFor='integration_host'>Host Name</label>
                                <input type='search' id='hname' onChange={(e) => { inputdata(e) }} value={edit_val.hname ? edit_val.hname : ''} />
                            </div>
                            <div>
                                <label htmlFor='integration_user'>User Name</label>
                                <input type='search' id='user' onChange={(e) => { inputdata(e) }} value={edit_val.user ? edit_val.user : ''} />
                            </div>
                            <div>
                                <label htmlFor='integration_password'>User Password</label>
                                <input type='search' id='password' onChange={(e) => { inputdata(e) }} value={edit_val.password ? edit_val.password : ''} />
                            </div>
                            <div>
                                <label htmlFor='c_type'>Access Type</label>
                                <select id='c_type' onChange={(e) => { inputdata(e) }} value={edit_val.c_type ? edit_val.c_type : ''}>
                                    <option>Select Type</option>
                                    <option value={"In Bound"}>In Bound</option>
                                    <option value={"Out Bound"}>Out Bound</option>
                                </select>
                            </div>
                        </div>
                        <div className='w100 h10 df jc ac gap1 white'>
                            <button className='btn h_blue' onClick={check}>Check</button>
                            <button className='btn green' onClick={submit}>Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Edit_Configuration;